import { Button, IconButton, TextareaAutosize, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Box from "elements/Box";
import { ProjectConfig } from "Global";
import { useSnackbar, withSnackbar } from "notistack";
import App from "elements/HtmlEditor/App";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import Categorias from "elements/Categorias";
import LangTabs from "elements/LangTabs";

export default withSnackbar(function AcuerdosCategoryEditor(props: any) {
  /*SNACKBAR FUNCTION FOR NOTIFICATIONS*/
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  /*============================================= */

  /*=======================================
      GET PROJECT ID AND ESTIMATE ID FROM URL
    =======================================*/
  let { acuerdos_category_id } = useParams();
  /*=======================================
    =======================================*/

  const navigate = useNavigate();
  const defaultValues: any = {
    acuerdos_category_id: acuerdos_category_id ? acuerdos_category_id : "null",
    title: "",
  };

  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState(defaultValues);
  const [files, setFiles] = useState<any>([]);
  const [currentLangId, setCurrentLangId] = useState<string>("1");
  const [translations, setTranslations] = useState<Record<string, any>>({});
  interface pdfData {
    file_id: any;
    file: any;
    name: string;
    estado: string;
  }

  const [filesPdf, setFilesPdf] = useState<pdfData[]>([]);

  const handleInputChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleLangChange = (langId: string) => {
    setCurrentLangId(langId);
  };

  const getCurrentTitle = () => {
    if (currentLangId === "1") return formValues.title || "";
    return translations[currentLangId]?.title || "";
  };

  const handleTitleChange = (value: string) => {
    if (currentLangId === "1") {
      setFormValues((prev: any) => ({ ...prev, title: value }));
    } else {
      setTranslations((prev) => ({
        ...prev,
        [currentLangId]: {
          ...prev[currentLangId],
          title: value,
        },
      }));
    }
  };

  interface SubCategoria {
    id: number;
    padre_id: number;
    label: string;
    titulo: string;
    contentJSON: any | null; // Puedes reemplazar 'any' con el tipo correcto si lo tienes definido
    contentJSON_send: any | null; // Puedes reemplazar 'any' con el tipo correcto si lo tienes definido
    contentHTML: string;
    contentHTML_send: string;
    estado: string;
    delete: number;
    orden: number;
  }

  interface Categoria {
    id: number;
    label: string;
    titulo: string;
    contentJSON: any | null; // Puedes reemplazar 'any' con el tipo correcto si lo tienes definido
    contentJSON_send: any | null; // Puedes reemplazar 'any' con el tipo correcto si lo tienes definido
    contentHTML: string;
    contentHTML_send: string;
    subCategorias: SubCategoria[];
    estado: string;
    tipo: string;
    delete: number;
  }

  /*=======================================
      GET DETAILS IF EDITING
    =======================================*/
  useEffect(() => {
    if (acuerdos_category_id) {
      axios
        .get(ProjectConfig.api_url, {
          params: {
            request: "acuerdos_category_details",
            id: acuerdos_category_id,
          },
        })
        .then((response) => {
          console.log("formValues", response.data);
          setFormValues(response.data);
          setCategoriasAll(response.data.categorias);
          setFilesPdf(response.data.files);
          if (response.data.translations) {
            setTranslations(response.data.translations);
          }
          const hasTextCategoria = response.data.categorias.some(
            (categoria: Categoria) => categoria.tipo === "Texto"
          );
          if (hasTextCategoria) {
            settextView(true);
          }
        })
        .catch((err) => {
          console.log(err.data);
        });
    }
  }, []);
  /*=======================================
    =======================================*/

  /*=======================================
      SUBMIT
    =======================================*/

  const handleSubmit = () => {
    console.log(formValues);
    const formValuesWithTranslations = {
      ...formValues,
      translations: translations,
    };
    const formData = new FormData();
    formData.append("formValues", JSON.stringify(formValuesWithTranslations));
    formData.append("categorias", JSON.stringify(categorias_send));
    for (let i = 0; i < files.length; i++) {
      formData.append(`files[${i}]`, files[i]);
    }

    // Agregar archivos PDF al FormData
    for (let i = 0; i < filesPdf.length; i++) {
      formData.append(`filesPdf[${i}][file_id]`, filesPdf[i].file_id);
      formData.append(`filesPdf[${i}][file]`, filesPdf[i].file);
      formData.append(`filesPdf[${i}][name]`, filesPdf[i].name);
      formData.append(`filesPdf[${i}][estado]`, filesPdf[i].estado);
    }
    //AXIOS
    axios
      .post(ProjectConfig.api_url, formData, {
        params: {
          request: "add_edit_acuerdos_categorias",
          formValues: formValues,
        },
      })
      .then((response) => {
        console.log(response);
        if (response.data) {
          navigate("/admin/acuerdos/categorias");
        } else {
          enqueueSnackbar("Error al guardar", { variant: "error" });
        }
      })
      .catch((err) => {
        console.log(err.data);
      });
  };
  /*====================================
    =====================================*/

  const [textView, settextView] = useState(false);
  const [textCaudro, settextCaudro] = useState(false);

  const [categoriasAll, setCategoriasAll] = useState<Categoria[]>([]);
  const [categorias_send, setCategorias_send] = useState<Categoria[]>([]);
  const [progress, setProgress] = useState(0);

  const [ident, setident] = useState(100000);
  const [identSub, setidentSub] = useState(200000);

 

  const borrar_file = (directorio_id: Number) => {
    const formData = new FormData();
    formData.append("archivo_id", JSON.stringify(directorio_id));
    //AXIOS
    axios
      .post(ProjectConfig.api_url, formData, {
        onUploadProgress: (progressEvent) => {
          setProgress(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        },
        params: {
          request: "delete_archivo",
        },
      })
      .then((response) => {
        console.log(response);
        if (response.data) {
          setFormValues({
            ...formValues,
            filePdf: "",
            file_id: 0,
          });
        } else {
          enqueueSnackbar("Error al borrar", { variant: "error" });
        }
      })
      .catch((err) => {
        console.log(err.data);
      });
  };

  // const [ident, setident] = useState(1000000001);
  const add_file = () => {
    setFilesPdf((current) => [
      ...current,
      {
        file_id: ident,
        file: "",
        name: "",
        estado: "nuevo",
      },
    ]);
    setident(ident + 1);
  };

  const handleFileInputChange = (
    file_id: number,
    file: any,
    name: string,
    estado: string
  ) => {
    actualizarFile(file_id, file, name, estado);

    //
  };

  const actualizarFile = (
    file_id: number,
    file: any,
    name: string,
    estado: string
  ) => {
    if (estado == "nuevo") {
      setFilesPdf((prevFile) =>
        prevFile.map((pdfRow) =>
          pdfRow.file_id === file_id
            ? {
                ...pdfRow,
                file: file,
                name: name,
              }
            : pdfRow
        )
      );
    } else {
      setFilesPdf((prevFile) =>
        prevFile.map((pdfRow) =>
          pdfRow.file_id === file_id
            ? {
                ...pdfRow,
                file: file,
                name: name,
                estado: "editable",
              }
            : pdfRow
        )
      );
    }

    // console.log(filesPdf);
  };

  const handleTituloInputChange = (id: any, value: any) => {
    actualizarTituloPorIdPdf(id, value);

    //
  };

  const actualizarTituloPorIdPdf = (file_id: any, name: any) => {
    setFilesPdf((prevFile) =>
      prevFile.map((pdfRow) =>
        pdfRow.file_id === file_id
          ? {
              ...pdfRow,
              name: name,
            }
          : pdfRow
      )
    );
  };

  const borrarPorIdPdf = (file_id: number) => {
    borrar_file(file_id);
    setFilesPdf((prevPdf) =>
      prevPdf.filter((file) => file.file_id !== file_id)
    );
  };

  

  return (
    <div id="AcuerdosForm">
      <div className="userForm_right">
        <Box
          id="acuerdos_editor"
          className="box_editor"
          title="Acuerdos"
          subtitle="Editar"
        >
          <div className="input_group">
            <div className="input_group">
              <div className="input_row">
                <LangTabs
                  currentLangId={currentLangId}
                  onChange={handleLangChange}
                />
                <TextField
                  id="title"
                  name="title"
                  label="Título"
                  type="text"
                  required
                  fullWidth
                  multiline
                  value={getCurrentTitle()}
                  onChange={(e) => handleTitleChange(e.target.value)}
                  sx={{ width: "500px" }}
                />
              </div>
            </div>

            <Categorias
            categorias={categoriasAll}
            setCategorias_send={setCategorias_send}
          />
          
          </div>
          {filesPdf.length > 0 &&
            filesPdf.map((fileRow, index) => (
              <div key={index}>
                {/* <p>  Hola </p> */}
                {/* <p>  {fileRow.name} </p> */}
                <label>Titulo</label>
                <div className="inputColumn">
                  <input
                    type="text"
                    name={"titulo_" + index}
                    id={"titulo_" + index}
                    onChange={(e) =>
                      actualizarTituloPorIdPdf(fileRow.file_id, e.target.value)
                    }
                    value={fileRow.name}
                  />
                </div>
                {/* <br/> */}
                <br />
                <div className="drawerImagesContainer">
                  <div
                    id="multimediaFileDropBox"
                    className={
                      "drawerImagesContainerDiv " +
                      (fileRow.file != "" ? "hasFile" : "")
                    }
                    onDrop={(e) => {
                      e.preventDefault();
                      // UPDATE FILE
                      const files = e.dataTransfer.files;
                      const fileName = files[0].name;
                      console.log("fileName 1");
                      console.log(fileName);
                      handleFileInputChange(
                        fileRow.file_id,
                        files[0],
                        fileName,
                        fileRow.estado
                      );

                      const fileArray = Array.from(files).map((file: any) =>
                        URL.createObjectURL(file)
                      );

                      e.currentTarget.classList.remove("dropzone_active");
                    }}
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.currentTarget.classList.add("dropzone_active");
                    }}
                    onDragLeave={(e) => {
                      e.preventDefault();
                      e.currentTarget.classList.remove("dropzone_active");
                    }}
                  >
                    {fileRow.file && (
                      <span className="fileUploaded">
                        <AttachFileIcon />
                        {fileRow.name}
                      </span>
                    )}

                    <label
                      id="dropFileDiv"
                      className={fileRow.file && "showOnlyOnHover"}
                    >
                      <IconButton
                        aria-label="delete"
                        size="small"
                        className="addFile_button"
                        component="span"
                      >
                        <FileUploadIcon />

                        <input
                          type="file"
                          multiple
                          hidden
                          accept=".pdf"
                          onChange={(e) => {
                            const files = e.target.files;
                            if (files) {
                              //get file name
                              const fileName = files[0].name;
                              // console.log("fileName 2")
                              // console.log(fileName)
                              // UPDATE FILE
                              handleFileInputChange(
                                fileRow.file_id,
                                files[0],
                                fileName,
                                fileRow.estado
                              );
                              const fileArray = Array.from(files).map(
                                (file: any) => URL.createObjectURL(file)
                              );
                            }
                          }}
                        />
                      </IconButton>
                      Arrastra aquí un archivo o da click para subirlo.
                    </label>
                  </div>
                  {fileRow.file != "" && (
                    <Button
                      onClick={() => borrarPorIdPdf(fileRow.file_id)}
                      variant="contained"
                      className="button_1"
                    >
                      Borrar
                    </Button>
                  )}
                </div>
              </div>
            ))}

          <>
            <br></br>
            <br></br>
            {/* <br></br> */}
            <Button onClick={add_file} variant="contained" className="button_1">
              Agregar PDF
            </Button>
          </>
          <div className="buttons">
            <Button
              onClick={() => navigate(-1)}
              variant="outlined"
              className="button_2"
            >
              Cancelar
            </Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              className="button_1"
            >
              Guardar
            </Button>
          </div>
        </Box>
      </div>
    </div>
  );
});
